// src/sim/damage.ts -- pure, no DOM
import type { Terrain } from './terrain';

/**
 * Calculate damage based on distance from blast center.
 * Linear falloff: full damage at center, zero at blast edge.
 */
export function calcDamage(
  distance: number,
  blastRadius: number,
  maxDamage: number,
): number {
  if (distance >= blastRadius) return 0;
  return Math.round(maxDamage * (1 - distance / blastRadius));
}

/**
 * Apply burial damage to a tank based on solid pixels above it.
 * Counts solid pixels from tank top (y-4) upward for 26 rows.
 * Damage = floor(buriedPixels / 2). Burial damage ignores shields.
 */
export function applyBurialDamage(
  tank: { x: number; y: number; hp: number; alive: boolean },
  terrain: Terrain,
): void {
  let buriedPixels = 0;
  const topY = tank.y - 4;
  const scanLimit = Math.max(0, topY - 26);

  for (let y = topY; y >= scanLimit; y--) {
    if (terrain.isSolid(tank.x, y)) buriedPixels++;
  }

  const damage = Math.floor(buriedPixels / 2);
  if (damage > 0) {
    tank.hp -= damage;
    if (tank.hp <= 0) tank.alive = false;
  }
}
